/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkUserActionSkipped } from './BulkUserActionSkipped';
import {
    BulkUserActionSkippedFromJSON,
    BulkUserActionSkippedFromJSONTyped,
    BulkUserActionSkippedToJSON,
    BulkUserActionSkippedToJSONTyped,
} from './BulkUserActionSkipped';

/**
 * 
 * @export
 * @interface BulkUserActionResponse
 */
export interface BulkUserActionResponse {
    /**
     * Count of users the action was applied to
     * @type {number}
     * @memberof BulkUserActionResponse
     */
    processed: number;
    /**
     * 
     * @type {Array<BulkUserActionSkipped>}
     * @memberof BulkUserActionResponse
     */
    skipped: Array<BulkUserActionSkipped>;
}

/**
 * Check if a given object implements the BulkUserActionResponse interface.
 */
export function instanceOfBulkUserActionResponse(value: object): value is BulkUserActionResponse {
    if (!('processed' in value) || value['processed'] === undefined) return false;
    if (!('skipped' in value) || value['skipped'] === undefined) return false;
    return true;
}

export function BulkUserActionResponseFromJSON(json: any): BulkUserActionResponse {
    return BulkUserActionResponseFromJSONTyped(json, false);
}

export function BulkUserActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUserActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'processed': json['processed'],
        'skipped': ((json['skipped'] as Array<any>).map(BulkUserActionSkippedFromJSON)),
    };
}

export function BulkUserActionResponseToJSON(json: any): BulkUserActionResponse {
    return BulkUserActionResponseToJSONTyped(json, false);
}

export function BulkUserActionResponseToJSONTyped(value?: BulkUserActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'processed': value['processed'],
        'skipped': ((value['skipped'] as Array<any>).map(BulkUserActionSkippedToJSON)),
    };
}

